import React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const TextRenderer = ({ data }) => {
  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      title={
        <div style={{ whiteSpace: 'pre-line', fontSize: '1em', boxSizing: 'border-box' }}>
          {getInvestors()}
        </div>
      }
    />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 500,
      maxHeight: 500,
      margin: 10
    }
  });

  const getInvestorsCount = () => {
    return data?.length;
  };

  const getInvestors = () => {
    const investors = data?.map((item) => item.invstor_name);
    return investors?.join('\n');
  };

  return (
    <div>
      <CustomWidthTooltip>
        <Button sx={{ m: 1 }}>{getInvestorsCount()}</Button>
      </CustomWidthTooltip>
    </div>
  );
};
